import './shared/variables.css';
import acfInputAddress from './components/acf-input-address/index.js';
import acfLeafletMap from './components/acf-leafletmap/index.js';

function init() {
	acfLeafletMap();
	acfInputAddress();
}

document.addEventListener( 'DOMContentLoaded', init );
